import Udesk from 'Udesk';
import { getRouteNameWithNameSpace } from 'Udesk/system/subApp';

export const getRouteNameWithCA = getRouteNameWithNameSpace(
    Udesk.enums.sysModuleList.conversationAnalysis.nameSpace
);

const conversationAnalysisRoutesGlobal = [
    {
        path: '/conversation-analysis',
        name: getRouteNameWithCA('home'),
        routes: [
            // 概览
            {
                path: '/dashboard',
                authCode: 'voc:overview',
                name: getRouteNameWithCA('dashboard'),
            },

            // 智能分析
            {
                path: '/intelligent-analysis',
                authCode: 'smart:root',
                name: getRouteNameWithCA('intelligentAnalysis'),
                routes: [
                    // 智能标签
                    {
                        path: '/intelligent-tags',
                        name: getRouteNameWithCA('intelligentTags'),
                        authCode: 'smart:tag:root',
                        routes: [
                            {
                                path: '/smart-conversation',
                                authCode: 'smart:qualityInspectTag:root',
                                name: getRouteNameWithCA('smartConversationIntelligentTags'),
                                routes: [
                                    {
                                        path: '/index',
                                        name: getRouteNameWithCA('intelligentTagsIndex'),
                                    },
                                    {
                                        path: '/new',
                                        authCode: 'smart:tag:add',
                                        name: getRouteNameWithCA('intelligentTagsNew'),
                                    },
                                    {
                                        path: '/edit/:id',
                                        authCode: 'smart:tag:edit',
                                        name: getRouteNameWithCA('intelligentTagsEdit'),
                                    },
                                ],
                            },
                            {
                                path: '/sentiment-tags',
                                name: getRouteNameWithCA('sentimentTags'),
                                routes: [
                                    {
                                        path: '/index',
                                        name: getRouteNameWithCA('sentimentTagsIndex'),
                                    },
                                    {
                                        path: '/new',
                                        authCode: 'smart:tag:add',
                                        name: getRouteNameWithCA('sentimentTagsNew'),
                                    },
                                    {
                                        path: '/edit/:id',
                                        authCode: 'smart:tag:edit',
                                        name: getRouteNameWithCA('sentimentTagsEdit'),
                                    },
                                ],
                            },
                            {
                                path: '/user-label',
                                authCode: 'smart:userTag:root',
                                name: getRouteNameWithCA('userLabel'),
                                routes: [
                                    {
                                        path: '/index',
                                        name: getRouteNameWithCA('userLabelTagsIndex'),
                                    },
                                    {
                                        path: '/new',
                                        authCode: 'smart:tag:add',
                                        name: getRouteNameWithCA('userLabelTagsNew'),
                                    },
                                    {
                                        path: '/edit/:id',
                                        authCode: 'smart:tag:edit',
                                        name: getRouteNameWithCA('userLabelTagsEdit'),
                                    },
                                ],
                            },
                            {
                                path: '/product-label',
                                authCode: 'smart:productTag:root',
                                name: getRouteNameWithCA('productLabel'),
                                routes: [
                                    {
                                        path: '/index',
                                        name: getRouteNameWithCA('productLabelTagsIndex'),
                                    },
                                    {
                                        path: '/new',
                                        authCode: 'smart:tag:add',
                                        name: getRouteNameWithCA('productLabelTagsNew'),
                                    },
                                    {
                                        path: '/edit/:id',
                                        authCode: 'smart:tag:edit',
                                        name: getRouteNameWithCA('productLabelTagsEdit'),
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },

            // 产品管理
            {
                path: '/product-manage',
                name: getRouteNameWithCA('productManage'),
                authCode: 'voc:product',
                routes: [
                    {
                        path: '/list',
                        name: getRouteNameWithCA('productManageList'),
                    },
                    {
                        path: '/detail/:id',
                        name: getRouteNameWithCA('productManageDetail'),
                        routes: [
                            {
                                path: '/base-info',
                                name: getRouteNameWithCA('productManageDetailBaseInfo'),
                            },
                            {
                                path: '/sub-product',
                                name: getRouteNameWithCA('productManageDetailSubProduct'),
                            },
                            {
                                path: '/acoustic-data',
                                name: getRouteNameWithCA('productManageDetailAcousticData'),
                                routes: [
                                    {
                                        path: '/voice',
                                        name: getRouteNameWithCA(
                                            'productManageDetailAcousticDataVoice'
                                        ),
                                    },
                                    {
                                        path: '/text',
                                        name: getRouteNameWithCA(
                                            'productManageDetailAcousticDataText'
                                        ),
                                    },
                                    {
                                        path: '/ticket',
                                        name: getRouteNameWithCA(
                                            'productManageDetailAcousticDataTicket'
                                        ),
                                    },
                                    {
                                        path: '/survey',
                                        name: getRouteNameWithCA(
                                            'productManageDetailAcousticDataSurvey'
                                        ),
                                    },
                                    {
                                        path: '/video',
                                        name: getRouteNameWithCA(
                                            'productManageDetailAcousticDataVideo'
                                        ),
                                    },
                                    {
                                        path: '/wecom',
                                        name: getRouteNameWithCA(
                                            'productManageDetailAcousticDataWecom'
                                        ),
                                    },
                                    {
                                        path: '/media',
                                        name: getRouteNameWithCA(
                                            'productManageDetailAcousticDataMedia'
                                        ),
                                    },
                                    {
                                        path: '/application',
                                        name: getRouteNameWithCA(
                                            'productManageDetailAcousticDataApplication'
                                        ),
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },

            // 产品详情
            {
                path: '/product-detail',
                name: getRouteNameWithCA('productDetail'),
                authCode: 'voc:product:detail',
                routes: [
                    {
                        path: '/list/index',
                        name: getRouteNameWithCA('productDetailList'),
                    },
                ],
            },

            // 数据分析
            {
                path: '/data-analysis',
                authCode: 'data:analysis:root',
                name: getRouteNameWithCA('dataAnalysis'),
                routes: [
                    // 统计概况
                    {
                        path: '/statistical-profile',
                        name: getRouteNameWithCA('statisticalProfile'),
                        authCode: 'smart:statistical:overview',
                    },

                    // 舆情分析
                    {
                        path: '/public-sentiment',
                        name: getRouteNameWithCA('sentimentAnalysis'),
                        authCode: 'smart:discovery:root',
                        routes: [
                            {
                                path: '/analysis',
                                name: getRouteNameWithCA('sentimentAnalysisIndex'),
                            },
                        ],
                    },

                    // 用户洞察
                    {
                        path: '/user-insight',
                        name: getRouteNameWithCA('userInsight'),
                        authCode: 'smart:user:insight',
                    },

                    // 产品洞察
                    {
                        path: '/product-insight',
                        name: getRouteNameWithCA('productInsight'),
                        authCode: 'smart:product:insight',
                    },

                    // 产品统计
                    {
                        path: '/product-statistics',
                        name: getRouteNameWithCA('productStatistics'),
                        authCode: 'smart:product:statistics',
                    },

                    // 业务分析
                    {
                        path: '/business-analysis',
                        name: getRouteNameWithCA('businessAnalysis'),
                        authCode: 'smart:analysis:root',
                        routes: [
                            {
                                path: '/list/index',
                                name: getRouteNameWithCA('businessAnalysisList'),
                            },
                            {
                                path: '/detail/:id',
                                name: getRouteNameWithCA('businessAnalysisDetail'),
                            },
                            {
                                path: '/create',
                                name: getRouteNameWithCA('businessAnalysisCreate'),
                            },
                        ],
                    },

                    // 竞品分析
                    {
                        path: '/competitive-product-analysis',
                        name: getRouteNameWithCA('competitiveProductAnalysis'),
                        // authCode: 'inspection:inspectorWorkload:root',
                    },

                    // 标签分析
                    {
                        path: '/intelligent-tags-analysis',
                        name: getRouteNameWithCA('intelligentTagsAnalysis'),
                        // authCode: 'inspection:inspectorWorkload:root',
                    },
                    // 社媒舆情
                    {
                        path: '/social-media-sentiment',
                        name: getRouteNameWithCA('socialMediaSentiment'),
                        // authCode: 'inspection:inspectorWorkload:root',
                    },
                ],
            },

            // 原声管理
            {
                path: '/soundtrack-manage',
                name: getRouteNameWithCA('soundtrackManage'),
                authCode: 'voc:manage',
                routes: [
                    {
                        path: '/index',
                        name: getRouteNameWithCA('soundtrackManageIndex'),
                    },
                ],
            },

            //客户中心
            {
                path: '/client-center',
                name: 'conversationAnalysisClientCenterEntry',
                authCode: 'customer:root',
                routes: [
                    {
                        path: '/manage',
                        name: 'conversationAnalysisClientManageRoot',
                        routes: [
                            {
                                path: '/index',
                                name: 'conversationAnalysisClientManage',
                            },
                            {
                                path: '/wechat-index',
                                name: 'conversationAnalysisClientManageWechat',
                            },
                        ],
                    },
                    // 客户画像
                    {
                        path: '/customer-portrait',
                        name: 'conversationAnalysisCustomerPortrait',
                        authCode: 'smart:personal:root',
                        routes: [
                            {
                                path: '/index',
                                name: 'conversationAnalysisCustomerPortraitIndex',
                            },
                        ],
                    },
                ],
            },
            {
                path: '/semantic-intelligence',
                authCode: 'semantic:root',
                name: getRouteNameWithCA('semanticIntelligence'),
                routes: [
                    // 智能词库
                    {
                        path: '/smart-words-library',
                        name: getRouteNameWithCA('smartWordsLibrary'),
                        authCode: 'semantic:corpora:root',
                        routes: [
                            {
                                path: '/hot-words',
                                name: getRouteNameWithCA('smartWordsLibraryHotWords'),
                            },
                            {
                                path: '/hot-words-detail/:id',
                                name: 'conversationAnalysisSmartWordsLibraryHotWordsDetail',
                            },
                            {
                                path: '/synonym-words',
                                name: getRouteNameWithCA('smartWordsLibrarySynonymWords'),
                            },
                            {
                                path: '/sensitive-words',
                                name: getRouteNameWithCA('smartWordsLibrarySensitiveWords'),
                            },
                            {
                                path: '/professional-words',
                                name: getRouteNameWithCA('smartWordsLibraryProfessionalWords'),
                            },
                            {
                                path: '/attention-words',
                                name: getRouteNameWithCA('smartWordsLibraryAttentionWords'),
                            },
                            {
                                path: '/ignore-words',
                                name: getRouteNameWithCA('smartWordsLibraryIgnoreWords'),
                            },
                            {
                                path: '/words-weight',
                                name: getRouteNameWithCA('smartWordsLibraryWordsWeight'),
                            },
                            {
                                path: '/corpus-data',
                                name: getRouteNameWithCA('smartWordsLibraryCorpusData'),
                            },
                            {
                                path: '/typo-library',
                                name: getRouteNameWithCA('smartWordsLibraryTypoLibrary'),
                            },
                        ],
                    },
                    // 概念词
                    {
                        path: '/concept-word',
                        name: getRouteNameWithCA('conceptWord'),
                        authCode: 'semantic:conceptWords:root',
                        routes: [
                            {
                                path: '/index',
                                name: getRouteNameWithCA('conceptWordIndex'),
                            },
                            {
                                path: '/new',
                                authCode: 'semantic:conceptWords:add',
                                name: getRouteNameWithCA('conceptWordNew'),
                            },
                            {
                                path: '/edit/:id',
                                authCode: 'semantic:conceptWords:edit',
                                name: getRouteNameWithCA('conceptWordEdit'),
                            },
                        ],
                    },
                    // 语义标签
                    {
                        path: '/semantic-tags',
                        name: 'conversationAnalysisSemanticTags',
                        authCode: 'semantic:semanticTag:root',
                        routes: [
                            {
                                path: '/index',
                                name: getRouteNameWithCA('semanticTagsIndex'),
                            },
                            {
                                path: '/new',
                                authCode: 'semantic:semanticTag:add',
                                name: getRouteNameWithCA('semanticTagsNew'),
                            },
                            {
                                path: '/edit/:id',
                                authCode: 'semantic:semanticTag:edit',
                                name: getRouteNameWithCA('semanticTagsEdit'),
                            },
                        ],
                    },
                    // 信息实体
                    {
                        path: '/information-entities',
                        name: getRouteNameWithCA('informationEntities'),
                        authCode: 'semantic:imformation:root',
                        routes: [
                            {
                                path: '/index',
                                name: getRouteNameWithCA('informationEntitiesIndex'),
                            },
                            {
                                path: '/new',
                                authCode: 'semantic:imformation:add',
                                name: getRouteNameWithCA('informationEntitiesNew'),
                            },
                            {
                                path: '/edit/:id',
                                authCode: 'semantic:imformation:edit',
                                name: getRouteNameWithCA('informationEntitiesEdit'),
                            },
                        ],
                    },
                    // 交互识别
                    {
                        path: '/interactive-recognition',
                        name: 'conversationAnalysisInteractiveRecognition',
                        authCode: 'semantic:interactive:root',
                        routes: [
                            {
                                path: '/index',
                                name: 'conversationAnalysisInteractiveRecognitionIndex',
                            },
                            {
                                path: '/new',
                                authCode: 'semantic:interactive:add',
                                name: 'conversationAnalysisInteractiveRecognitionNew',
                            },
                            {
                                path: '/edit/:id',
                                authCode: 'semantic:interactive:edit',
                                name: 'conversationAnalysisInteractiveRecognitionEdit',
                            },
                        ],
                    },
                    {
                        path: '/knowledge-base',
                        name: getRouteNameWithCA('knowledgeBase'),
                        authCode: 'semantic:knowledgeData:root',
                        routes: [
                            {
                                path: '/index',
                                name: getRouteNameWithCA('knowledgeBaseIndex'),
                            },
                            {
                                path: '/new',
                                authCode: 'semantic:knowledgeData:add',
                                name: getRouteNameWithCA('knowledgeBaseNew'),
                            },
                            {
                                path: '/edit/:id',
                                authCode: 'semantic:knowledgeData:edit',
                                name: getRouteNameWithCA('knowledgeBaseEdit'),
                            },
                        ],
                    },
                    // 数据预处理
                    {
                        path: '/data-preprocess',
                        name: 'conversationAnalysisDataPreprocess',
                        authCode: 'datapre:rule:root',
                        routes: [
                            {
                                path: '/index',
                                authCode: 'datapre:rule:view',
                                name: 'conversationAnalysisDataPreprocessIndex',
                            },
                            {
                                path: '/new',
                                authCode: 'datapre:rule:save',
                                name: 'conversationAnalysisDataPreprocessNew',
                            },
                            {
                                path: '/edit/:id',
                                authCode: 'datapre:rule:update',
                                name: 'conversationAnalysisDataPreprocessEdit',
                            },
                        ],
                    },
                ],
            },
            // 训练中心
            {
                path: '/training-center',
                name: 'conversationAnalysisTrainingCenter',
                authCode: 'training:root',
                routes: [
                    // 快速训练
                    {
                        path: '/fast-training',
                        name: 'conversationAnalysisFastTrainingIndex',
                        authCode: 'training:fast:root',
                    },
                    // 训练历史
                    {
                        path: '/training-history',
                        name: 'conversationAnalysisTrainingHistoryIndex',
                        authCode: 'training:history:root',
                    },
                    // 分类训练
                    {
                        path: '/classified-training',
                        name: 'conversationAnalysisClassifiedTraining',
                        authCode: 'training:categoryTrain:train',
                        routes: [
                            {
                                path: '/index',
                                name: 'conversationAnalysisClassifiedTrainingIndex',
                            },
                            {
                                path: '/detail/:id',
                                name: 'conversationAnalysisClassifiedTrainingDetail',
                            },
                        ],
                    },
                    // 分类训练历史
                    {
                        path: '/classified-history-training',
                        name: 'conversationAnalysisClassifiedTrainingHistoryIndex',
                        authCode: 'training:categoryTrain:trainHistory',
                    },
                    // 聚类标注
                    {
                        path: '/clustering-annotation-index',
                        name: 'conversationAnalysisClusteringAnnotationIndex',
                        authCode: 'training:clusterMark:root',
                    },
                ],
            },
            // 通话管理
            {
                path: '/call-manage',
                authCode: 'call:root',
                name: 'conversationAnalysisCallManage',
                routes: [
                    {
                        path: '/index',
                        name: 'conversationAnalysisCallManageIndex',
                    },
                    {
                        path: '/view/:id',
                        name: 'conversationAnalysisCallManageView',
                    },
                ],
            },
            // 对话管理
            {
                path: '/dialogue-manage',
                authCode: 'im:root',
                name: 'conversationAnalysisDialogueManage',
                routes: [
                    {
                        path: '/index',
                        name: 'conversationAnalysisDialogueManageIndex',
                    },
                    {
                        path: '/view/:id',
                        name: 'conversationAnalysisDialogueManageView',
                    },
                ],
            },
            // 工单管理
            {
                path: '/ticket-manage',
                authCode: 'ticket:root',
                name: 'conversationAnalysisTicketManage',
                routes: [
                    {
                        path: '/index',
                        name: 'conversationAnalysisTicketManageIndex',
                    },
                    {
                        path: '/view/:id',
                        name: 'conversationAnalysisTicketManageView',
                    },
                ],
            },
            // 电商会话管理
            {
                path: '/e-commerce-manage',
                authCode: 'mallcall:root',
                name: 'conversationAnalysisECommerceManage',
                routes: [
                    {
                        path: '/index',
                        name: 'conversationAnalysisECommerceManageIndex',
                    },
                    {
                        path: '/view/:id',
                        name: 'conversationAnalysisECommerceManageView',
                    },
                ],
            },
            // 数据管理
            {
                path: '/data-integration',
                name: 'dataIntegration',
                authCode: 'sys:data:integration:root',
                routes: [
                    //CC
                    {
                        path: '/cc-pass',
                        name: getRouteNameWithCA('systemIntegrationCCpass'),
                    },
                    //企微对接
                    {
                        path: '/wecom',
                        name: getRouteNameWithCA('wechatDocking'),
                    },
                    {
                        path: '/taobao',
                        name: getRouteNameWithCA('taobaoDocking'),
                    },
                    //微丰对接
                    {
                        path: '/weifeng',
                        name: getRouteNameWithCA('weifengDocking'),
                    },
                    {
                        path: '/zendesk',
                        name: getRouteNameWithCA('systemIntegrationZendesk'),
                        routes: [
                            {
                                path: '/ticket',
                                name: getRouteNameWithCA('zendeskTicket'),
                            },
                            {
                                path: '/chat',
                                name: getRouteNameWithCA('zendeskChat'),
                            },
                        ],
                    },
                    {
                        path: '/amazon',
                        name: getRouteNameWithCA('amazonList'),
                        authCode: 'sys:module:list:root',
                        routes: [
                            {
                                path: '/index',
                                name: getRouteNameWithCA('amazonListIndex'),
                            },
                        ],
                    },
                    {
                        path: '/youtube',
                        name: getRouteNameWithCA('youtubeList'),
                        authCode: 'sys:module:list:root',
                        routes: [
                            {
                                path: '/index',
                                name: getRouteNameWithCA('youtubeListIndex'),
                            },
                        ],
                    },
                ],
            },
            // 视频分析
            {
                path: '/video-analysis',
                name: getRouteNameWithCA('videoAnalysis'),
                routes: [
                    {
                        path: '/index',
                        name: getRouteNameWithCA('videoAnalysisList'),
                    },
                    {
                        path: '/view/:id',
                        name: getRouteNameWithCA('videoAnalysisDetail'),
                    },
                ],
            },
            // 系统设置
            {
                path: '/admin',
                authCode: 'sys:setting:root',
                name: getRouteNameWithCA('adminEntry'),
                routes: [
                    // 系统设置
                    {
                        path: '/system/index',
                        name: getRouteNameWithCA('adminSystemIndex'),
                        authCode: 'sys:info:root',
                    },
                    // 语音识别
                    {
                        path: '/speech-recognition/index',
                        name: getRouteNameWithCA('speechRecognitionIndex'),
                        authCode: 'sys:voice:root',
                    },
                    // 消息日志
                    {
                        path: '/system-log/index',
                        name: getRouteNameWithCA('systemLogIndex'),
                        authCode: 'sys:message:root',
                    },
                    // 员工管理
                    {
                        path: '/user',
                        name: getRouteNameWithCA('adminUserEntry'),
                        authCode: 'sys:user:root',
                        routes: [
                            {
                                path: '/index',
                                name: getRouteNameWithCA('adminUserIndex'),
                            },
                            {
                                path: '/view/:id',
                                name: getRouteNameWithCA('adminUserView'),
                                authCode: 'sys:user:view',
                            },
                            {
                                path: '/new',
                                name: getRouteNameWithCA('adminUserNew'),
                                authCode: 'sys:user:add',
                            },
                            {
                                path: '/edit/:id',
                                name: getRouteNameWithCA('adminUserEdit'),
                                authCode: 'sys:user:edit',
                            },
                        ],
                    },
                    // 员工组管理
                    {
                        path: '/user-groups',
                        name: getRouteNameWithCA('adminUserGroupsEntry'),
                        authCode: 'sys:group:root',
                        routes: [
                            {
                                path: '/index',
                                name: getRouteNameWithCA('adminUserGroupsIndex'),
                            },
                            {
                                path: '/view/:id',
                                name: getRouteNameWithCA('adminUserGroupsView'),
                                authCode: 'sys:group:view',
                            },
                            {
                                path: '/new',
                                name: getRouteNameWithCA('adminUserGroupsNew'),
                                authCode: 'sys:group:add',
                            },
                            {
                                path: '/edit/:id',
                                name: getRouteNameWithCA('adminUserGroupsEdit'),
                                authCode: 'sys:group:edit',
                            },
                        ],
                    },
                    // 角色管理
                    {
                        path: '/role',
                        name: getRouteNameWithCA('role'),
                        authCode: 'sys:role:root',
                        routes: [
                            {
                                path: '/index',
                                name: getRouteNameWithCA('roleIndex'),
                            },
                            {
                                path: '/new',
                                name: getRouteNameWithCA('roleNew'),
                                authCode: 'sys:role:add',
                                routes: [
                                    {
                                        path: '/index',
                                        name: getRouteNameWithCA('roleNewBasicInfo'),
                                    },
                                ],
                            },
                            {
                                path: '/view/:id',
                                name: getRouteNameWithCA('roleView'),
                                authCode: 'sys:role:view',
                                routes: [
                                    {
                                        path: '/basic-info',
                                        name: getRouteNameWithCA('roleViewBasicInfo'),
                                    },
                                    {
                                        path: '/task-permissions',
                                        name: getRouteNameWithCA('roleViewTaskPermissions'),
                                    },
                                    {
                                        path: '/data-permissions',
                                        name: getRouteNameWithCA('roleViewDataPermissions'),
                                    },
                                ],
                            },
                            {
                                path: '/edit/:id',
                                name: getRouteNameWithCA('roleEdit'),
                                authCode: 'sys:role:edit',
                                routes: [
                                    {
                                        path: '/basic-info',
                                        name: getRouteNameWithCA('roleEditBasicInfo'),
                                    },
                                    {
                                        path: '/task-permissions',
                                        name: getRouteNameWithCA('roleEditTaskPermissions'),
                                    },
                                    {
                                        path: '/data-permissions',
                                        name: getRouteNameWithCA('roleEditDataPermissions'),
                                    },
                                ],
                            },
                        ],
                    },
                    // 数据迁移
                    {
                        path: '/data-migration/index',
                        name: getRouteNameWithCA('dataMigration'),
                        authCode: 'sys:dataTransfer:root',
                    },
                    // 任务中心
                    {
                        path: '/task-center',
                        name: getRouteNameWithCA('taskCenter'),
                        authCode: 'sys:impExp:root',
                        routes: [
                            {
                                path: '/download-list',
                                name: getRouteNameWithCA('taskCenterDownloadList'),
                            },
                            {
                                path: '/upload-list',
                                name: getRouteNameWithCA('taskCenterUploadList'),
                            },
                            {
                                path: '/task-list',
                                name: getRouteNameWithCA('taskCenterTaskList'),
                            },
                        ],
                    },
                    // 计费中心
                    {
                        path: '/billing-center',
                        name: getRouteNameWithCA('billingCenterIndex'),
                        authCode: 'hc:charge:root',
                    },
                    // 财务中心（计费系统账单，由计费 sdk 渲染）
                    {
                        path: '/finance-center',
                        name: getRouteNameWithCA('financeCenterIndex'),
                        authCode: 'hc:charge:root',
                    },
                    //客户字段
                    {
                        path: '/customer-field',
                        name: getRouteNameWithCA('customerField'),
                        authCode: 'sys:customer:field',
                    },
                    // 本地录音上传
                    {
                        path: '/record-upload/index',
                        name: getRouteNameWithCA('recordUploadIndex'),
                        authCode: 'sys:voiceUpload:root',
                    },
                    {
                        path: '/record-upload/upload-call',
                        name: getRouteNameWithCA('recordUploadDetail'),
                        authCode: 'sys:voiceUpload:root',
                    },
                    {
                        path: '/record-upload/upload-im',
                        name: getRouteNameWithCA('recordUploadDetailIm'),
                        authCode: 'sys:voiceUpload:root',
                    },
                    {
                        path: '/anomalous-data',
                        name: getRouteNameWithCA('anomalousData'),
                        authCode: 'sys:dataAbnormal:root',
                        routes: [
                            {
                                path: '/index',
                                name: getRouteNameWithCA('anomalousDataIndex'),
                            },
                        ],
                    },
                    //logo设置
                    {
                        path: '/logo-site',
                        name: getRouteNameWithCA('logoSite'),
                        // authCode: ('sys:customer:field'),
                    },

                    // 业务工作时间
                    {
                        path: '/business-working-hours',
                        name: getRouteNameWithCA('businessWorkingHours'),
                        authCode: 'sys:work:time',
                    },

                    // 质检语言设置
                    {
                        path: '/qa-language-setting',
                        name: getRouteNameWithCA('qaLanguageSetting'),
                        authCode: 'multilingual:setting:root',
                        routes: [
                            // 语音通话
                            {
                                path: '/voice',
                                name: getRouteNameWithCA('qaLanguageSettingVoice'),
                            },
                            // 文本对话
                            {
                                path: '/text',
                                name: getRouteNameWithCA('qaLanguageSettingText'),
                            },
                            // 工单
                            {
                                path: '/ticket',
                                name: getRouteNameWithCA('qaLanguageSettingTicket'),
                            },
                            // 视频通话
                            {
                                path: '/video',
                                name: getRouteNameWithCA('qaLanguageSettingVideo'),
                            },
                            // 电商评论数据
                            {
                                path: '/e-comment',
                                name: getRouteNameWithCA('qaLanguageSettingEComment'),
                            },
                            // 社媒评论数据
                            {
                                path: '/m-comment',
                                name: getRouteNameWithCA('qaLanguageSettingMComment'),
                            },
                            // 社媒评论数据
                            {
                                path: '/wechat-dialogue',
                                name: getRouteNameWithCA('qaLanguageSettingWechatDialogue'),
                            },
                            // 社媒评论数据
                            {
                                path: '/wechat-radio',
                                name: getRouteNameWithCA('qaLanguageSettingWechatRadio'),
                            },
                            // 问卷
                            {
                                path: '/survey',
                                name: getRouteNameWithCA('qaLanguageSettingSurvey'),
                            },
                        ],
                    },
                ],
            },

            // 电商评论管理
            {
                path: '/e-comment-manage',
                authCode: 'call:root',
                name: 'conversationAnalysisECommentManage',
                routes: [
                    {
                        path: '/index',
                        name: 'conversationAnalysisECommentManageIndex',
                    },
                    {
                        path: '/view/:id',
                        name: 'conversationAnalysisECommentManageDetail',
                    },
                ],
            },
            // 社媒评论管理
            {
                path: '/m-comment-manage',
                authCode: 'call:root',
                name: 'conversationAnalysisMCommentManage',
                routes: [
                    {
                        path: '/index',
                        name: 'conversationAnalysisMCommentManageIndex',
                    },
                    {
                        path: '/view/:id',
                        name: 'conversationAnalysisMCommentManageDetail',
                    },
                ],
            },

            // todo: 权限
            // 计划管理
            {
                path: '/plan-manage',
                // authCode: 'call:root',
                name: getRouteNameWithCA('planManage'),
                routes: [
                    // 自动触发消息
                    {
                        path: '/automatic-trigger-message',
                        name: getRouteNameWithCA('automaticTriggerMessage'),
                        // authCode: 'smart:tag:root',
                    },
                ],
            },

            // 404
            {
                path: '/404',
                name: 'conversationAnalysisPageNotFound',
            },
        ],
    },
];

export { conversationAnalysisRoutesGlobal };
